module.exports = __webpack_public_path__ + "img/LV44103027762.d4ae2c59.png";